__turbopack_context__.v({
  "input": "Switcher-module-scss-module__G3JkCq__input",
  "root": "Switcher-module-scss-module__G3JkCq__root",
});
